import { useContext } from "react";
import { NavContext } from "@/src/context/";

export const useNav = () => useContext(NavContext);
